// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"705":"7f5c01b1","879":"5da7eee4"}[chunkId] + ".chunk.css";
};